import Cookies from 'js-cookie';
import moment from 'moment';

export const logoutSessions = () => {
  Cookies.set('new_ssid', undefined, { secure: true, sameSite: 'None' });
};

export const setCookie = (name, value, duration = 100, timeUnit = undefined) => {
  const options = {
    secure: true,
    SameSite: 'None'
  };

  if (!timeUnit || timeUnit === 'days') {
    options.expires = duration;
  } else if (timeUnit === 'timestamp') {
    options.expires = new Date(duration * 1000); // ms
  } else {
    options.expires = moment()
      .add(duration, timeUnit)
      .toDate();
  }

  removeCookie(name);
  Cookies.set(name, value, options);

  return getCookie(name);
};

export const getCookie = name => {
  return Cookies.get(name);
};

export const removeCookie = name => {
  Cookies.remove(name, { secure: true, sameSite: 'None' });
};
